import React, { useState } from "react";
import {
  signInWithEmailAndPassword,
  PhoneAuthProvider,
  multiFactor,
  PhoneMultiFactorGenerator,
  getMultiFactorResolver,
  RecaptchaVerifier,
} from "firebase/auth";
import { auth } from "../firebase_config";
import "../forms.css";
import { margin } from "@mui/system";
import SixDigitInput from "./SixDigitInput";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [resolver, setResolver] = useState(null);
  const [verificationId, setVerificationId] = useState("");
  const [step, setStep] = useState("login"); // "login", "mfa", "done"
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
  
    try {
      await signInWithEmailAndPassword(auth, email, password);
      console.log("✅ Inloggad utan MFA");
      setStep("done");
    } catch (err) {
      if (err.code === "auth/multi-factor-auth-required") {
        console.log("🔐 MFA krävs");
      
        const mfaResolver = getMultiFactorResolver(auth, err);
        setResolver(mfaResolver);
      
        const phoneInfo = mfaResolver.hints[0];
        const phoneAuthProvider = new PhoneAuthProvider(auth);
      
        // 🧼 Rensa tidigare verifierare om den finns
        if (window.recaptchaVerifier) {
          try {
            window.recaptchaVerifier.clear();
          } catch (e) {
            console.warn("⚠️ Kunde inte rensa tidigare reCAPTCHA:", e);
          }
          window.recaptchaVerifier = null;
        }
      
        // 🆕 Skapa ny verifierare
        window.recaptchaVerifier = new RecaptchaVerifier(
          "recaptcha-container",
          {
            size: "invisible",
            callback: (response) => {
              console.log("✅ reCAPTCHA löst (MFA):", response);
            },
          },
          auth
        );
      
        await window.recaptchaVerifier.render();
      
        const verificationId = await phoneAuthProvider.verifyPhoneNumber(
          {
            multiFactorHint: phoneInfo,
            session: mfaResolver.session,
          },
          window.recaptchaVerifier
        );
      
        setVerificationId(verificationId);
        setStep("mfa");
        console.log("📲 SMS skickat, verificationId:", verificationId);
      } else {
        console.error("❌ Login error:", err);
        setError(err.message);
      }
    }
  };

  const handleVerifyCode = async (customCode = code) => {
    try {
      const cred = PhoneAuthProvider.credential(verificationId, customCode);
      const assertion = PhoneMultiFactorGenerator.assertion(cred);
      const userCredential = await resolver.resolveSignIn(assertion);
      console.log("✅ Inloggad med MFA:", userCredential.user);
      setStep("done");
    } catch (err) {
      console.error("❌ Verifieringsfel:", err);
      setError(err.message);
    }
  };

  return (
    <div className="center">
      <div className="auth">
        <h1>Logga in</h1>
        {error && <div className="auth__error">{error}</div>}

        {step === "login" && (
          <>
            <form onSubmit={handleLogin}>
              <input
                type="email"
                value={email}
                required
                placeholder="E-post"
                onChange={(e) => setEmail(e.target.value)}
              />

              <input
                type="password"
                value={password}
                required
                placeholder="Lösenord"
                onChange={(e) => setPassword(e.target.value)}
              />

              <button type="submit">Logga in</button>
            </form>
            <p>Om du behöver ett konto, <a href="/register">registrera här</a></p>
          </>
        )}

        {step === "mfa" && (
          <form onSubmit={(e) => {
            e.preventDefault();
            handleVerifyCode();
          }}>
            <p>Verifieringskod skickad! Ange SMS-koden:</p>
            <SixDigitInput onComplete={(val) => {
              setCode(val);
              handleVerifyCode(val);
            }} />
            <br />
            <button type="submit" style={{ marginTop: "0px" }}>
              Verifiera kod
            </button>
          </form>
        )}
        {step === "done" && (
          <p>✅ Inloggning slutförd!</p>
        )}

        {/* 🔐 Osynlig recaptcha-container måste finnas */}
        <div id="recaptcha-container"></div>
      </div>
    </div>
  );
}

export default Login;